var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.42901 8.00047C10.7738 8.00047 12.6742 6.20943 12.6742 4.00023C12.6742 1.79104 10.7738 0 8.42901 0C6.08423 0 4.18386 1.79104 4.18386 4.00023C4.18386 6.20943 6.08423 8.00047 8.42901 8.00047ZM8.42901 1.00006C10.1848 1.00006 11.6129 2.34576 11.6129 4.00023C11.6129 5.65439 10.1848 7.00041 8.42901 7.00041C6.67324 7.00041 5.24515 5.65346 5.24515 4.00023C5.24515 2.34576 6.67457 1.00006 8.42901 1.00006ZM10.1105 9.50056H6.74753C3.57395 9.50056 1 11.9257 1 14.9165C1 15.5147 1.51472 16 2.14951 16H14.7092C15.344 16.0009 15.858 15.5165 15.858 14.9165C15.858 11.9257 13.2844 9.50056 10.1105 9.50056ZM14.7072 15.0009H2.14951C2.10108 15.0009 2.06129 14.9634 2.06129 14.9165C2.06129 12.482 4.16396 10.5006 6.74753 10.5006H10.1072C12.6941 10.5006 14.7967 12.482 14.7967 14.9165C14.7967 14.9634 14.7569 15.0009 14.7072 15.0009Z",
    fill: "#149CE0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserOutline);
export default __webpack_public_path__ + "static/media/user-outline.bcf2d14238435838d89d0696ceefa5c7.svg";
export { ForwardRef as ReactComponent };